"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingStatusDecoder = exports.effortUnitDecoder = void 0;
var ts_data_json_1 = require("ts.data.json");
var feature_flags_1 = __importDefault(require("./feature-flags"));
var integration_1 = require("./integration");
var timestamp_1 = __importDefault(require("./timestamp"));
var githubIntegrationPreviewDecoder = ts_data_json_1.JsonDecoder.object({
    id: ts_data_json_1.JsonDecoder.string,
    service: ts_data_json_1.JsonDecoder.isExactly('github'),
    installationId: ts_data_json_1.JsonDecoder.string,
    ownerName: ts_data_json_1.JsonDecoder.string,
    ownerType: integration_1.GithubIntegrationOwnerTypeDecoder,
}, 'GithubIntegrationPreview');
var gitlabIntegrationPreviewDecoder = ts_data_json_1.JsonDecoder.object({
    id: ts_data_json_1.JsonDecoder.string,
    service: ts_data_json_1.JsonDecoder.isExactly('gitlab'),
}, 'GitlabIntegrationPreview');
var slackIntegrationPreviewDecoder = ts_data_json_1.JsonDecoder.object({
    id: ts_data_json_1.JsonDecoder.string,
    service: ts_data_json_1.JsonDecoder.isExactly('slack'),
}, 'GithubIntegrationPreview');
var integrationStanzaDecoder = ts_data_json_1.JsonDecoder.oneOf([githubIntegrationPreviewDecoder, gitlabIntegrationPreviewDecoder, slackIntegrationPreviewDecoder], 'Organization.IntegrationStanza');
exports.effortUnitDecoder = ts_data_json_1.JsonDecoder.oneOf([ts_data_json_1.JsonDecoder.isExactly('days'), ts_data_json_1.JsonDecoder.isExactly('hours'), ts_data_json_1.JsonDecoder.isExactly('storyPoints')], 'Organization.EffortUnit');
exports.OnboardingStatusDecoder = ts_data_json_1.JsonDecoder.oneOf([ts_data_json_1.JsonDecoder.isExactly('pending'), ts_data_json_1.JsonDecoder.isExactly('finished')], 'Organization.OnboardingStatus');
exports.default = ts_data_json_1.JsonDecoder.object({
    name: ts_data_json_1.JsonDecoder.string,
    orgDomain: ts_data_json_1.JsonDecoder.array(ts_data_json_1.JsonDecoder.string, 'string[]'),
    featureFlags: feature_flags_1.default,
    integrations: ts_data_json_1.JsonDecoder.array(integrationStanzaDecoder, 'Organization.IntegrationStanza[]'),
    nextTaskSlug: ts_data_json_1.JsonDecoder.number,
    createdAt: timestamp_1.default,
    updatedAt: timestamp_1.default,
    deletedAt: ts_data_json_1.JsonDecoder.optional(timestamp_1.default),
    logoURL: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.string),
    color: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.string),
    effortUnit: exports.effortUnitDecoder,
    totalSprintsCount: ts_data_json_1.JsonDecoder.number,
    completedSprintsCount: ts_data_json_1.JsonDecoder.number,
    totalTasksCount: ts_data_json_1.JsonDecoder.number,
    onboardingStatus: exports.OnboardingStatusDecoder,
    premiumSubscription: ts_data_json_1.JsonDecoder.optional(ts_data_json_1.JsonDecoder.string),
}, 'Organization');
